// GummieVerse — Light / Dark color mode toggle.
// Pairs with the inline bootstrap script in layout/theme.liquid (which sets
// html[data-color-mode] before first paint) and the CSS overrides in
// snippets/gv-color-modes.liquid.

const STORAGE_KEY = 'gv-color-mode'
const root = document.documentElement

function applyMode(mode, { persist } = { persist: false }) {
	root.setAttribute('data-color-mode-transition', 'true')
	root.setAttribute('data-color-mode', mode)

	const meta = document.querySelector('meta[name="theme-color"]')
	const gv = window.themeVariables && window.themeVariables.gv && window.themeVariables.gv.colorMode
	if (meta && gv) {
		meta.setAttribute('content', mode === 'light' ? gv.metaThemeColorLight : gv.metaThemeColorDark)
	}

	if (persist) {
		try {
			window.localStorage.setItem(STORAGE_KEY, mode)
		} catch (error) {
			// Storage may be unavailable (private browsing, disabled cookies, etc).
			// The mode still applies for the current page view.
		}
	}

	window.clearTimeout(applyMode._transitionTimeout)
	applyMode._transitionTimeout = window.setTimeout(() => {
		root.removeAttribute('data-color-mode-transition')
	}, 250)

	document.dispatchEvent(new CustomEvent('gv:color-mode-change', { detail: { mode } }))
}

// Keep following the OS/browser preference live, but only until the visitor
// makes an explicit manual choice (once they do, we stop overriding them).
if (window.matchMedia) {
	const media = window.matchMedia('(prefers-color-scheme: light)')
	const onSystemChange = (event) => {
		let hasManualChoice = true
		try {
			hasManualChoice = window.localStorage.getItem(STORAGE_KEY) !== null
		} catch (error) {
			hasManualChoice = false
		}
		if (!hasManualChoice) {
			applyMode(event.matches ? 'light' : 'dark', { persist: false })
		}
	}
	if (media.addEventListener) {
		media.addEventListener('change', onSystemChange)
	} else if (media.addListener) {
		// Older Safari
		media.addListener(onSystemChange)
	}
}

class ThemeModeToggle extends HTMLElement {
	connectedCallback() {
		this.button = this.querySelector('button')
		this.label = this.querySelector('[data-color-mode-label]')
		if (!this.button) return

		this.onClick = this.onClick.bind(this)
		this.button.addEventListener('click', this.onClick)

		this.onModeChange = this.onModeChange.bind(this)
		document.addEventListener('gv:color-mode-change', this.onModeChange)

		this.reflectState()
	}

	disconnectedCallback() {
		if (this.button) this.button.removeEventListener('click', this.onClick)
		document.removeEventListener('gv:color-mode-change', this.onModeChange)
	}

	onClick() {
		const current = root.getAttribute('data-color-mode') === 'light' ? 'light' : 'dark'
		const next = current === 'light' ? 'dark' : 'light'
		applyMode(next, { persist: true })
	}

	onModeChange() {
		this.reflectState()
	}

	reflectState() {
		const isLight = root.getAttribute('data-color-mode') === 'light'
		this.button.setAttribute('aria-pressed', String(isLight))
		if (this.label) {
			this.label.textContent = isLight
				? this.dataset.labelDark || 'Switch to dark mode'
				: this.dataset.labelLight || 'Switch to light mode'
		}
	}
}

if (!window.customElements.get('theme-mode-toggle')) {
	window.customElements.define('theme-mode-toggle', ThemeModeToggle)
}
